import Link from "next/link";
import { Fragment } from "react";
import { ChevronLeft } from "lucide-react";
import { get_breadcrumbs_JsonLd_server } from "@core/helpers/server/getJsonLds";
import JsonLd from "@core/helpers/json-ld-script";

// «خانه» به ریشه‌ی همان بخش می‌رود: فروشگاه "/"، بلاگ "/blogs/"، سلر آکادمی "/seller-academy/"
export const BLOG_HOME_HREF = "/blogs/";
export const SELLER_ACADEMY_HOME_HREF = "/seller-academy/";

const trim_slash = (href) => (href || "").replace(/\/+$/, "");

export default async function Breadcrumb({ data = [], className, homeHref = "/" }) {
  // آیتم ابتدایی‌ای که به همان خانه‌ی بخش اشاره کند (مثلاً «مقالات» → /blogs/) تکراری است
  const items = [...(data || [])];
  while (items.length && items[0]?.href && trim_slash(items[0].href) === trim_slash(homeHref)) items.shift();
  const breadcrumbItems = [{ title: "خانه", href: homeHref }, ...items];

  const jsonLd = await get_breadcrumbs_JsonLd_server(breadcrumbItems);

  return (
    <nav className={`py-4 ${className || ''}`} aria-label="breadcrumb">
      <JsonLd data={jsonLd} />
      <ol className="flex items-center w-full overflow-auto hide-scrollbar">
        {breadcrumbItems.map((item, index) => {
          const isLast = index === breadcrumbItems.length - 1;

          const text_class = `whitespace-nowrap ${isLast ? "text-jmt-neutral-900" : "text-jmt-neutral-500"
            }`;

          return (
            <Fragment key={`breadcrumb-item-keys-${index}`}>
              <li className="flex items-center text-xs gap-1">
                {/* آیتم‌های بدون href (سطح‌های ساختاری مثل «دسته‌بندی‌ها» و خودِ
                    صفحه‌ی جاری) جایی برای رفتن ندارند، پس لینک نمی‌شوند و نه
                    hover می‌گیرند نه شکل کلیک‌پذیر */}
                {item?.href ? (
                  <Link
                    className={`${text_class} transition-colors hover:text-jmt-main`}
                    href={item.href}
                  >
                    {item?.title}
                  </Link>
                ) : (
                  <span className={text_class}>{item?.title}</span>
                )}
                {!isLast && (
                  <ChevronLeft size={18} strokeWidth={1} className="text-jmt-neutral-500" />
                )}
              </li>


            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
}
